import { render, staticRenderFns } from "./account-history.vue?vue&type=template&id=322e491f&scoped=true&"
import script from "./account-history.vue?vue&type=script&lang=js&"
export * from "./account-history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322e491f",
  null
  
)

export default component.exports